import React from 'react';
import heroVideo from '../assets/hero-video.mp4';
import Footer from './Footer.tsx';

export default function HeroSection() {
  return (
    <section className="hero">
      <video className="hero-video" src={heroVideo} autoPlay muted loop playsInline />
      <div className="hero-content">
        <p className="theme-intro"><strong>2025’s theme is…</strong></p>
        <h1 className="hero-title"><strong>Finding Our Way: <br/>
        The Lighthouse of Faith </strong></h1>
        <p className="hero-date">
          <strong>
          Saturday, November 8<br />
          Islamic Community of Bryan-College Station (ICBCS)<br />
          417 Stasney St, College Station, TX 77840 </strong>
        </p>
        <p className="hero-text">
          <strong>In times of confusion, change, and spiritual drift, the heart yearns for clarity and direction. This year’s theme,
          "Finding Our Way: The Lighthouse of Faith," calls us to anchor ourselves in divine guidance—
          using the Qur'an and Sunnah as our compass amid life’s turbulent seas. Like a lighthouse illuminating the path for weary travelers, faith offers constancy, hope, and vision.</strong>

          <br /><br />
          <strong>Through this theme, we will explore how to rekindle spiritual awareness, revive the heart, and find steady ground through prayer, companionship, and purposeful growth. Whether you’re seeking direction, healing, or deeper conviction, this year’s conference is an invitation to journey back to the light of Allah.</strong>
        </p>
        <button className="registration-btn" onClick={() => window.location.href = '/Registration'}>
          Register
        </button>
        <button className="program-details-btn" onClick={() => window.location.href = '/ProgramDetails'}>
          Program Details
        </button>
      </div>
      <Footer />
    </section>
  );
}